module.exports = __webpack_public_path__ + "img/armor-cloak.b16d4a1c.svg";